import React, { ReactElement, useEffect, useRef } from 'react';
import { Content, Label, Wrapper } from './Droplist.styled';
import { ComponentProps as Props } from './Droplist.types';

const Droplist: React.FC<Props> = ({
  children,
  options,
  onOptionClick,
  optionSelectedKey,
  ...props
}): ReactElement<Props> => {
  const refs = useRef(new Array(options.length).fill(null));
  const getRef = (element, key) => (refs.current[key] = element);

  useEffect(() => {
    if (refs.current[optionSelectedKey])
      refs.current[optionSelectedKey].scrollIntoView({ block: 'nearest', behaviour: 'smooth' });
  }, [optionSelectedKey]);

  return (
    <Wrapper {...props}>
      <Content>
        {options.map((option, key) => (
          <Label
            key={`label-${key}`}
            selected={option.selected}
            ref={(el) => getRef(el, key)}
            focused={key === optionSelectedKey}
            onClick={() => onOptionClick(option, key)}>
            {option.render ? option.render() : option.label}
          </Label>
        ))}
      </Content>
    </Wrapper>
  );
};

export default Droplist;
